module.exports = __webpack_public_path__ + "img/6.554a2684.jpg";